import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="py-20">
      <div className="max-w-screen-xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-0">
        {/* Left: Text */}
        <div className="border border-gray-100 px-8 md:px-12 py-12 flex flex-col justify-center">
          <h3 className="text-3xl font-bold text-[#0b2240] mb-4">Learn About Our Agency</h3>
          <div className="flex items-center gap-2 mb-5">
            <i className="ri-map-pin-2-line text-[#3072b7] text-lg" />
            <a href="/contact" className="text-[#3072b7] font-semibold text-sm hover:underline">
              406 Hemphill St, Hattiesburg, MS 39401
            </a>
          </div>
          <div className="w-16 h-0.5 bg-[#3072b7] mb-6" />
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Effective insurance begins with specialists who approach your needs uniquely—professionals who comprehend your industry and recognize what's at stake for you. We leverage our expertise and experience to evaluate coverage benefits and premium costs from various carriers, providing you with the most suitable options.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-8">
            We are committed to our clients' financial security and quality of life, offering dedicated service, knowledgeable advice, and personalized attention from a reliable partner.
          </p>

          {/* Sub-section: Serving area */}
          <div className="flex flex-col sm:flex-row gap-4 items-start border-t border-gray-100 pt-6">
            <div className="flex-shrink-0 flex flex-col items-center gap-1 text-center min-w-[110px]">
              <i className="ri-map-2-line text-[#3072b7] text-3xl" />
              <span className="text-xs font-bold text-[#0b2240] mt-1">Serving Mississippi</span>
            </div>
            <div className="border-l-4 border-[#3072b7] pl-5">
              <p className="text-sm text-gray-600 mb-4">
                Reach out to our Hattiesburg, MS office and discover how we can assist you throughout Mississippi.
              </p>
              <div className="flex flex-wrap gap-3">
                <Link
                  to="/contact"
                  className="border-2 border-[#0b2240] text-[#0b2240] hover:bg-[#0b2240] hover:text-white text-sm font-bold px-5 py-2.5 rounded-md transition-colors whitespace-nowrap"
                >
                  Contact Us
                </Link>
                <Link
                  to="/about"
                  className="bg-[#3072b7] hover:bg-[#0b2240] text-white text-sm font-bold px-5 py-2.5 rounded-md transition-colors whitespace-nowrap"
                >
                  Learn About Us
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Right: Image + Review */}
        <div className="flex flex-col">
          {/* Image */}
          <div className="flex-1 min-h-[300px] lg:min-h-[380px] overflow-hidden">
            <img
              src="https://b3533217.smushcdn.com/3533217/wp-content/uploads/2024/12/Read-Our-Reviews-Cheerful-Young-Married-Couple-Spending-Time-Together-on-the-Sofa-While-Using-a-Tablet.jpg?lossy=2&strip=1&webp=1"
              alt="Happy clients"
              className="w-full h-full object-cover object-top"
            />
          </div>
          {/* Review Card */}
          <div className="bg-[#9cbde5] px-8 py-8 text-center">
            <div className="flex justify-center gap-1 text-yellow-400 text-lg mb-4">
              {[1,2,3,4,5].map((s) => <i key={s} className="ri-star-fill" />)}
            </div>
            <div className="w-12 h-0.5 bg-white/50 mx-auto mb-4" />
            <p className="text-[#0b2240] font-semibold text-sm italic leading-relaxed">
              "I hung up feeling happy, informed with the greatest feeling of ease and reassurance. Who can say that after discussing insurance?!?! ME that's who!"
            </p>
            <p className="text-[#0b2240] font-bold text-sm mt-3">— Angie H.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
